import styled from '@emotion/styled';
import { useState } from 'react';

import ChevronDownIcon from '@/assets/svg/ui-elements/chevron-down.svg';
import { hoverable, Typography } from '@/design-system';
import { theme } from '@/design-system/theme';

import { ReceiveBridgeFees } from './types';

export interface ReceiveFeesProps {
  fees: ReceiveBridgeFees;
}

const FeesCard = styled('section')(({ theme: t }) => ({
  display: 'flex',
  flexDirection: 'column',
  padding: t.spacing[12],
  borderRadius: t.radius[12],
  backgroundColor: t.colors.background.overlay,
}));
const FeesTrigger = styled('button')(({ theme: t }) => ({
  ...hoverable(t, 'surfaceRaised'),
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  minHeight: 44,
  padding: 0,
  border: 0,
  color: t.colors.text.primary,
  background: 'none',
  cursor: 'pointer',
  textAlign: 'left',
  touchAction: 'manipulation',
  WebkitTapHighlightColor: 'transparent',
  '&:focus-visible': { boxShadow: `0 0 0 2px ${t.colors.white[20]}` },
  '& svg': { width: 16, height: 16 },
}));
const FeesBody = styled('dl')(({ theme: t }) => ({
  display: 'grid',
  gridTemplateColumns: 'minmax(0, 1fr) auto',
  gap: t.spacing[8],
  margin: 0,
  paddingTop: t.spacing[12],
  borderTop: `1px solid ${t.colors.border.default}`,
  '& dt, & dd': { margin: 0 },
}));

export const ReceiveFees = ({ fees }: ReceiveFeesProps) => {
  const [open, setOpen] = useState(true);
  return (
    <FeesCard aria-label="Receive fees">
      <FeesTrigger type="button" aria-expanded={open} onClick={() => setOpen((value) => !value)}>
        <Typography as="span" variant="body2" fontWeight={500}>
          Fees
        </Typography>
        <ChevronDownIcon
          aria-hidden="true"
          style={{ transform: open ? 'rotate(180deg)' : undefined }}
        />
      </FeesTrigger>
      {open && (
        <FeesBody>
          <Typography as="dt" variant="body3" color={theme.colors.text.secondary}>
            Circle CCTP fee:
          </Typography>
          <Typography as="dd" variant="body3" fontWeight={500}>
            {fees.cctp}
          </Typography>
          <Typography as="dt" variant="body3" color={theme.colors.text.secondary}>
            Gamma bridging fee:
          </Typography>
          <Typography as="dd" variant="body3" fontWeight={500}>
            {fees.gamma}
          </Typography>
        </FeesBody>
      )}
    </FeesCard>
  );
};
